import React, { useEffect, useState } from "react";
import { Modal, Select, Form, Input, Button } from "antd";
// import RiderBrakeMark from "../riderBrakeMark";
import { swalNotification } from "../../../../../../components/alret/notificztion";
import { validationErrors } from "../../../../../../utils/Helpers";
import { getOrderDetailReassignRider } from "../../../../../../services/orderManagement.service";
import { getSingleStore } from "../../../../../../services/store.service";
import { getAvalibleRiderbyZone } from "../../../../../../services/riders.service";
const { Option } = Select;
const ModalReassignOrder = (props) => {
  const [postDataZone, setPostDataZone] = useState(null);
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [postDataRiderbyZone, setPostDataRiderbyZone] = useState(null);
  // const [postDataOrderIDF, setPostDataOrderIDF] = useState(null);
  // const [postDataOrderIDS, setPostDataOrderIDS] = useState(null);

  useEffect(() => {
    if (props.visible) {
      postLists();
    }
  }, [props.visible]);
  const postLists = async () => {
    try {
      setMBtnLoading(true);
      const singleStore = await getSingleStore(props.storeId);
      let zone_id = '';
      if(singleStore.data.code === 200){
        if(singleStore.data.data.zone) zone_id = singleStore.data.data.zone.id;
        setPostDataZone(singleStore.data.data.zone)
      }
      const respgetAvalibleRiderbyZone = await getAvalibleRiderbyZone(zone_id);
      setPostDataRiderbyZone(respgetAvalibleRiderbyZone.data.data);

      // console.log("order data", singleStore.data.data.zone)
      

      // const resp = await getZoneList();
      // setPostDataZone(resp.data.data);
      // const dataConvertID = [];
      // props.orderData.map((item) => {
      //   const dataid = {
      //     id: item.id,
      //   };
      //   dataConvertID.push(dataid);
      // });
      // setPostDataOrderIDF(dataConvertID[0].id);
      // setPostDataOrderIDS(dataConvertID[1].id);
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
    }
  };

  // const [MRSLoading, setMRSLoading] = useState(true);
  // const getzoneids = async (value) => {
  //   try {
  //     setMBtnLoading(true);
  //     setMRSLoading(true);
  //     const resp = await getRiderbyZone(value);
  //     setPostDataRiderbyZone(resp.data.data);
  //     setMRSLoading(false);
  //   } catch {
  //     // setErrMsg("Something went wrong");
  //   } finally {
  //     setMBtnLoading(false);
  //   }
  // };

  // const handleReassignPickup = async (values) => {
  //   try {
  //     let isEmpty = formObjectIsEmpty({
  //       taskId: postDataOrderIDF,
  //       riderId: values.riderId,
  //       reason: values.reason,
  //     });
  //     if (isEmpty) {
  //       throw Error("Invalid keys at Submit");
  //     }
  //     await getOrderDetailReassignRider({
  //       taskId: postDataOrderIDF,
  //       riderId: values.riderId,
  //       reason: values.reason,
  //     });
  //     // console.log("resp at handleCancelPickup =>> ", response.data);
  //   } catch (e) {
  //     throw e;
  //     // throw e.response.data.data.taskId;
  //   }
  // };

  // const handleReassignDeliver = async (values) => {
  //   try {
  //     let isEmpty = formObjectIsEmpty({
  //       taskId: postDataOrderIDS,
  //       riderId: values.riderId,
  //       reason: values.reason,
  //     });
  //     if (isEmpty) {
  //       throw new Error("Invalid keys at handleCancelOrder");
  //     }
  //     await getOrderDetailReassignRider({
  //       taskId: postDataOrderIDS,
  //       riderId: values.riderId,
  //       reason: values.reason,
  //     });
  //     // console.log("resp at handleCancelDeliver =>> ", response.data);
  //   } catch (e) {
  //     throw e;
  //   }
  // };

  const handleOkOrder = async (values) => {
    try {
      setMBtnLoading(true);
      const data = {
        orderId: props.OrderId,
        riderId: values.riderId,
        reason: values.reason,
      };
      const resp = await getOrderDetailReassignRider(data);
      if (resp.data.code == 200){
        swalNotification(
          "Rider Assign",
          resp.data.message,
          "success"
        );
      }
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }
  };
  const handleCancel = () => {
    props.setvisible(false);
  };

  useEffect(() => {
    form.setFieldsValue(postDataRiderbyZone);
  }, [postDataRiderbyZone]);
  const [form] = Form.useForm();

  return (
    <Modal
      title={`Force Assign Order ID #${props.OrderId}`}
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Cancel</Button>,
        <Button
          form="modalFormReassign"
          loading={MBtnLoading}
          htmlType="submit"
        >
          Order Force Assign to Rider
        </Button>,
      ]}
    >
      <Form
        form={form}
        id="modalFormReassign"
        layout="vertical"
        onFinish={handleOkOrder}
      >
        {props.orderRiderID && props.orderRiderID.fullName ? (
          <Form.Item label="Current rider">
            <Input value={props.orderRiderID.fullName} disabled />
          </Form.Item>
        ) : (
          ""
        )}
        <Form.Item
          label="Select Zone"
          rules={[{ required: true, message: "Zone is Required" }]}
        >
          {postDataZone && postDataZone.zoneName}
        </Form.Item>

        <Form.Item
          label="Assign to"
          name={"riderId"}
          rules={[{ required: true, message: "Rider is Required" }]}
        >
          <Select disabled={MBtnLoading} placeholder="Select Rider">
            {postDataRiderbyZone && postDataRiderbyZone.map((item) => (
              <Option value={item.id}>{item.fullName} - Batch: {item.batch?.batchLevel}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Reason for Assigning"
          name={"reason"}
          rules={[{ required: true, message: "Reason is Required" }]}
        >
          <Select>
            <Option disabled>Reason for Assigning</Option>
            <Option value="Bulk Order">Bulk Order</Option>
            <Option value="Grocery Order">Grocery Order</Option>
            <Option value="Same Customer Order">Same Customer Order</Option>
            <Option value="Same Location Order">Same Location Order</Option>
            <Option value="Bike Issue">Bike Issue</Option>
            <Option value="Equipment Issue">Equipment Issue</Option>
            <Option value="Mobile Data Package Expired">Mobile Data Package Expired</Option>
            <Option value="Incorrect Customer Address">Incorrect Customer Address</Option>
            <Option value="Incorrect Customer Location">Incorrect Customer Location</Option>
            <Option value="Forgot to Mark Drop-Off">Forgot to Mark Drop-Off</Option>
            <Option value="Network Issues">Network Issues</Option>
            <Option value="Order Status: Cancel to Completed">Order Status: Cancel to Completed</Option>
          </Select>
        </Form.Item>
      </Form>
      {/* {props.orderRiderID ? (
        <RiderBrakeMark brakeRiderid={props.orderRiderID} />
      ) : (
        ""
      )} */}
    </Modal>
  );
};

export default ModalReassignOrder;
